(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stats-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-section-type="stats-bar"]');
    if (!section) return;

    var targets = section.querySelectorAll('.sb__animate-number[data-target]');
    if (targets.length === 0) return;

    var animated = false;

    function animateNumbers() {
      if (animated) return;
      animated = true;

      targets.forEach(function(el) {
        var target = parseFloat(el.getAttribute('data-target'));
        var prefix = el.getAttribute('data-prefix') || '';
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1500;
        var start = 0;
        var startTime = null;
        var isDecimal = target % 1 !== 0;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = start + (target - start) * eased;

          if (isDecimal) {
            el.textContent = prefix + current.toFixed(1) + suffix;
          } else {
            el.textContent = prefix + Math.round(current).toLocaleString() + suffix;
          }

          if (progress < 1) {
            requestAnimationFrame(step);
          }
        }

        requestAnimationFrame(step);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            animateNumbers();
            observer.disconnect();
          }
        });
      }, { threshold: 0.3 });

      observer.observe(section);
    } else {
      animateNumbers();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
